export default "__VITE_ASSET__CXmm3LQt__"